export default {
  "unableToLoadOutlets": "Incapace di caricare le prese",
  "unableToLoadDiningAreas": "Incapace di caricare le zone pranzo",
  "unableToLoadTables": "Incapace di caricare i tavoli",
  "unableToLoadFloorPlan": "In grado di caricare il piano del pavimento",
  "couldNotUploadDiningImage": "Non poteva caricare l'immagine da pranzo",
  "diningImageSaved": "Immagine da pranzo salvata",
  "thePreviewIsTemporarilyUnavailableItWillAppearAutomaticallyWhenImageDeliveryRecovers": "L'anteprima è temporaneamente non disponibile. Verrà visualizzato automaticamente quando la consegna dell'immagine recupera.",
  "unableToSaveArea": "Incapace di salvare l'area",
  "chooseASupportedImage": "Scegli un'immagine supportata",
  "diningImageRemoved": "Rimozione dell'immagine da pranzo",
  "theChangeWasSavedButThePreviewServiceIsTemporarilyUnavailable": "Il cambiamento è stato salvato, ma il servizio di anteprima è temporaneamente non disponibile.",
  "unableToRemoveImage": "Incapace di rimuovere l'immagine",
  "unableToDeactivateArea": "Incapace di disattivare l'area",
  "cancellationPolicySaved": "Politica di cancellazione salvata",
  "unableToSaveTable": "Incapace di salvare la tabella",
  "qRDownloadReady": "QR download pronto",
  "yourPrivanaDiningQRFileHasBeenGenerated": "Il tuo file Dining QR Privana è stato generato.",
  "unableToGenerateQR": "Incapace di generare QR",
  "unableToLoadQRPreview": "Incapace di caricare l'anteprima QR",
  "thePublicQRURLHasBeenCopied": "L'URL del QR pubblico è stato copiato.",
  "unableToDeactivateTable": "Incapace di disattivare la tabella",
  "unableToBulkAddTables": "Non è possibile aggiungere alla rinfusa i tavoli",
  "floorPlanSaved": "Piano terra salvato",
  "yourLayoutChairsWallsAndDoorsWereSaved": "La disposizione, le sedie, le pareti e le porte sono state salvate.",
  "unableToSaveFloorPlan": "In grado di salvare il piano del pavimento",
  "openHostConsoleInANewTab": "Aprire Host Console in una nuova scheda",
  "openHostConsole": "Console di Host aperta",
  "addArea": "Aggiungi area",
  "diningAreas": "Aree di pranzo",
  "manageSharedRoomSectionsIndependentlyFromPOSOutletAssignments": "Gestisci sezioni di stanza condivise indipendentemente dalle assegnazioni di uscita POS.",
  "loadingDiningAreas": "Caricamento delle aree pranzo...",
  "noDiningAreasYetCreateYourFirstAreaToBegin": "Non c'è ancora zona pranzo. Crea la tua prima zona per iniziare.",
  "sharedDiningServiceSpace": "Sala di servizio di ristorazione condivisa",
  "active": "Attivo",
  "inactive": "Inattivo",
  "unableToUpdateArea": "Incapace di aggiornare l'area",
  "generateAreaQR": "Generare Area QR",
  "cancellationPolicy": "Politica di cancellazione",
  "edit": "Modifica",
  "deactivate": "Disattivare",
  "tables": "Tavole",
  "buildATableListForTheSelectedDiningArea": "Costruire un elenco di tabelle per la zona pranzo selezionata.",
  "diningArea": "Zona pranzo",
  "selectArea": "Seleziona l'area",
  "generateTableQRs": "Generare i QR della tabella",
  "bulkAdd": "Aggiungi Bulk",
  "addTable": "Aggiungere la tabella",
  "loadingTables": "Tavoli di carico...",
  "selectADiningAreaToViewTables": "Seleziona una zona pranzo per visualizzare i tavoli.",
  "thisArea": "questa zona",
  "table": "Tabella",
  "capacity": "Capacità:",
  "unableToUpdateTable": "Non è possibile aggiornare la tabella",
  "editDiningArea": "Modifica area pranzo",
  "addDiningArea": "Aggiungi zona pranzo",
  "areaName": "Nome dell'area",
  "restaurant": "Ristorante",
  "activeArea": "Area attiva",
  "enableOrDisableThisDiningArea": "Abilitare o disabilitare questa zona pranzo.",
  "diningImage": "Immagine di pranzo",
  "forBestResultsUseALandscapeImageAtLeast1600900pxJPEGPNGOrWebPUpTo5MB": "Per ottenere i migliori risultati, utilizzare un'immagine del paesaggio almeno 1600 × 900px. JPEG, PNG o WebP, fino a 5 MB.",
  "diningAreaPreview": "Anteprima zona pranzo",
  "previewUnavailableYourImageIsStillSaved": "Anteprima non disponibile — l'immagine è ancora salvata",
  "addAWelcomingDiningHero": "Aggiungi un accogliente eroe da pranzo",
  "replaceImage": "Sostituisci immagine",
  "uploadImage": "Carica immagine",
  "removeImage": "Rimuovi l'immagine",
  "altTextOptional": "Alt text (opzionale)",
  "candlelitTerraceOverlookingTheGarden": "Terrazza attrezzata con vista sul giardino",
  "horizontalFocus": "Concentrazione orizzontale",
  "verticalFocus": "Focus verticale",
  "securelySavingDiningArea": "Risparmio sicuro zona pranzo...",
  "cancel": "Annulla",
  "saving": "Salvataggio…",
  "saveArea": "Area di salvataggio",
  "thisDiningArea": "questa zona pranzo",
  "minimumNoticeHoursBeforeReservationStart": "Orari di preavviso minimo prima dell'inizio della prenotazione",
  "removeDiningImage": "Rimuovere l'immagine da pranzo?",
  "membersWillSeeYourClubHeroOrPrivanaSDiningFallbackInsteadThisCannotBeUndone": "I soci vedranno il vostro eroe club o Privana ristorante fallback invece. Questo non può essere annullato.",
  "keepImage": "Tenere l'immagine",
  "removing": "Rimozione...",
  "editTable": "Modifica della tabella",
  "addTableLabel": "Aggiungere la tabella",
  "label": "Etichetta",
  "table12": "Tabella 12",
  "capacityLabel": "Capacità",
  "activeTable": "Tabella attiva",
  "deactivateToHideThisTableOnPOS": "Disattivare per nascondere questo tavolo sul POS.",
  "saveTable": "Salva la tabella",
  "bulkAddTables": "Bulk aggiungere i tavoli",
  "startNumber": "Numero di inizio",
  "endNumber": "Numero di fine",
  "prefixOptional": "Prefisso (opzionale)",
  "capacityOptional": "Capacità (opzionale)",
  "createTables": "Creare tabelle",
  "fileType": "Tipo di file",
  "previewQRCode": "Anteprima Codice QR",
  "previewTableQRCodes": "Anteprima tabella codici QR",
  "loadingQRPreview": "Caricamento in anteprima QR...",
  "areaQRPreview": "Area Anteprima QR",
  "openLink": "Apri il link",
  "copyURL": "Copia URL",
  "open": "Apri",
  "copy": "Copia",
  "generating": "Generando...",
  "generateDownload": "Generare / scaricare",
  "checkIn": "Check-in",
  "seat": "Sedile",
  "complete": "Completo",
  "confirm": "Conferma",
  "staff": "Personale",
  "membersPortal": "Portale dei soci",
  "membersApp": "App per i soci",
  "guest": "Ospite",
  "walkIn": "Camminare",
  "accessDenied": "Accesso negato.",
  "unableToLoadDiningReservations": "Incapace di caricare le prenotazioni.",
  "today": "Oggi",
  "tomorrow": "Domani",
  "future": "Futuro",
  "functions": "Funzioni",
  "createReservation": "Creare la prenotazione",
  "addWalkIn": "Aggiungi Walk-In",
  "viewPastBookings": "Visualizza le prenotazioni passate",
  "manageTableBlocks": "Gestione dei blocchi da tavolo",
  "retry": "Riprova",
  "dismiss": "Discorso",
  "notesOrAllergyInformation": "Note o informazioni sull'allergia",
  "noReservations": "Nessuna prenotazione",
  "reservation": "Prenotazione",
  "date": "Data",
  "time": "Ora",
  "partySize": "Dimensione del partito",
  "duration": "Durata",
  "memberNotes": "Osservazioni",
  "staffNotes": "Osservazioni del personale",
  "reasonForCancelNoShow": "Motivo di annullamento / mancata presentazione",
  "saveChanges": "Salva le modifiche",
  "reject": "Rifiuti",
  "noShow": "Assente",
  "reservationType": "Tipo di prenotazione",
  "existingMember": "socio esistente",
  "memberSearch": "Ricerca dei soci",
  "searchMember": "socio della ricerca",
  "guestName": "Nome ospite",
  "email": "E-mail",
  "phone": "Telefono",
  "tableOptional": "Tabella (opzionale)",
  "createReservationLabel": "Creare la prenotazione",
  "pastBookings": "Prenotazioni passate",
  "memberGuestOrReference": "socio, ospite o riferimento",
  "allStatuses": "Tutti gli stati",
  "allAreas": "Tutte le aree",
  "search": "Cerca",
  "previous": "Precedente",
  "of": "di",
  "next": "Avanti",
  "reason": "Motivazione",
  "saveBlock": "Salva blocco",
  "addBlock": "Aggiungi blocco",
  "delete": "Elimina",
  "deleteTableBlock": "Eliminare il blocco della tabella?",
  "thisWillReturnTheTableToAvailabilityForTheBlockedPeriod": "Questo restituirà la tabella alla disponibilità per il periodo bloccato.",
  "keepBlock": "Tenere il blocco",
  "deleteBlock": "Elimina blocco",
  "autoAssign": "Assegna automaticamente",
  "sunday": "Domenica",
  "monday": "Lunedì",
  "tuesday": "Martedì",
  "wednesday": "Mercoledì",
  "thursday": "Giovedì",
  "friday": "Venerdì",
  "saturday": "Sabato",
  "addAtLeastOneServiceWindow": "Aggiungi almeno una finestra di servizio.",
  "minimumPartySizeCannotExceedMaximumPartySize": "La dimensione minima del partito non può superare la dimensione massima del partito.",
  "reservations": "Prenotazioni",
  "configureMemberAndGuestBookingAvailability": "Configurare la disponibilità di soci e prenotazioni degli ospiti.",
  "reservationDays": "Giorni di prenotazione",
  "serviceWindows": "Finestre di servizio",
  "addWindow": "Aggiungere la finestra",
  "windowStart": "Inizio finestra",
  "windowEnd": "Fine della finestra",
  "removeServiceWindow": "Rimuovi la finestra di servizio",
  "bookingIntervalMinutes": "Intervallo di prenotazione (minuti)",
  "defaultDurationMinutes": "Durata predefinita (minuti)",
  "minimumPartySize": "Dimensione minima del partito",
  "maximumPartySize": "Dimensione massima del partito",
  "maximumDaysAhead": "Durata massima",
  "minimumNoticeMinutes": "Avviso minimo (minuti)",
  "cancellationWindowMinutes": "Finestra di cancellazione (minuti)",
  "requireStaffApproval": "Richiedere l'approvazione del personale",
  "allowGuestReservations": "Consentire prenotazioni per gli ospiti",
  "allowWalkIns": "Consentire walk-in",
  "small": "Piccolo",
  "medium": "Medio",
  "large": "Grande",
  "general": "Generale",
  "mainDining": "Pranzo principale",
  "windowSeating": "Tavoli per finestre",
  "privateDining": "Sala da pranzo privata",
  "bar": "Bar",
  "patio": "Patio patio",
  "terrace": "Terrazza",
  "event": "Evento",
  "lounge": "Salotto",
  "quietArea": "Zona tranquilla",
  "familyArea": "Area famiglia",
  "highTop": "Alto livello",
  "staffOnly": "Solo personale",
  "custom": "Personalizzato",
  "round2": "Fase 2",
  "roundTables": "Tavolini rotondi",
  "round4": "Tondo 4",
  "round6": "Fase 6",
  "round8": "Fase 8",
  "square2": "Piazza 2",
  "squareTables": "Tavoli quadrati",
  "square4": "Piazza 4",
  "rectangle4": "Rettifica 4",
  "rectangleTables": "Tavole a rettangolo",
  "rectangle6": "Rettangolo 6",
  "rectangle8": "Rettangolo 8",
  "rectangle10": "Rettangolo 10",
  "ovalBanquet": "Ovale / banchetto",
  "specialSeating": "Sedili speciali",
  "booth": "Booth.",
  "barCounter": "Bar / banco",
  "serviceStation": "Stazione di servizio",
  "operations": "Operazioni",
  "diningZone": "Zona pranzo",
  "object": "Oggetto",
  "wallPath": "Sentiero di parete",
  "door": "Porta",
  "floorPlanImage": "Immagine piano terra",
  "selectionHandle": "Maniglia di selezione",
  "dining": "Ceneri",
  "floorPlanBuilder": "Piano di costruzione",
  "dragTablesDrawWallsToggleIndividualChairsAndSaveAClubScopedLayout": "Trascinare i tavoli, disegnare le pareti, attivare le singole sedie e salvare un layout a giroscopio.",
  "selectDiningArea": "Seleziona la zona pranzo",
  "selectAnArea": "Seleziona un'area",
  "reload": "Ricaricare",
  "save": "Salva",
  "duplicateTableLinksWereRepairedReviewUnlinkedTablesBeforeSaving": "I collegamenti di tabella duplicati sono stati riparati. Review tabelle non collegate prima di salvare.",
  "chooseADiningAreaToStart": "Scegli una zona pranzo per iniziare",
  "theBuilderWillKeepEachLayoutScopedToTheCurrentClubAndSelectedArea": "Il costruttore manterrà ogni layout per l'attuale club e l'area selezionata.",
  "palette": "Tavolozza tavolozza",
  "clickOrDragOntoTheCanvas": "Fare clic o trascinare sulla tela.",
  "select": "Seleziona",
  "wall": "Parete",
  "zone": "Zona",
  "ops": "Operazioni",
  "clickMoreWallPointsDoubleClickToFinishOrClickTheFirstPointToClose": "Fare clic su più punti di parete. Fare doppio clic per terminare, o fare clic sul primo punto per chiudere.",
  "clickTheWallStartPoint": "Fare clic sul punto di partenza della parete.",
  "clickMoreZonePointsDoubleClickToFinishOrClickTheFirstPointToClose": "Fare clic su più punti zona. Fare doppio clic per terminare, o fare clic sul primo punto per chiudere.",
  "clickTheFirstZonePoint": "Fare clic sul primo punto zona.",
  "dragToMoveItemsShiftClickToSelectMultiple": "Trascinare per spostare gli elementi. Fare clic su Shift per selezionare più.",
  "canvasSize": "Dimensione della tela",
  "tracingMode": "Modalità di tracciamento",
  "showZones": "Mostra zone",
  "zoneLegend": "Legenda della zona",
  "legend": "La leggenda",
  "keyboardShortcuts": "Tasti di scelta rapida",
  "wallTool": "Utensile da parete",
  "zoneTool": "Utensile di zona",
  "selectOrCancel": "Selezionare o annullare",
  "deleteSelected": "Eliminare selezionato",
  "duplicate": "Duplicare",
  "undo": "Condividi su Facebook",
  "redo": "Ripeti",
  "rotate15": "Ruotare 15°",
  "arrows": "Frecce",
  "nudgeShift5x": "Sposta leggermente (Maiusc = 5x)",
  "deleteObjects": "Eliminare gli oggetti",
  "exitFullScreen": "Uscita a schermo intero",
  "fullScreen": "Schermo intero",
  "loadingFloorPlan": "Piano di carico...",
  "uploadAFloorPlanImageAlignItLockItThenTraceWallsOverTheTop": "Caricare un'immagine piano pavimento, allinearla, bloccarla, poi tracciare pareti sopra la parte superiore.",
  "hideTracingMode": "Nascondere la modalità di tracciamento",
  "unlockImage": "Sblocca immagine",
  "lockImage": "Blocca immagine",
  "showBackgroundImage": "Mostra immagine di sfondo",
  "opacity": "OpacitÃ",
  "tracingImageOpacity": "Tracciare l'opacità dell'immagine",
  "rotation": "Rotazione",
  "tracingImageRotation": "Tracciare la rotazione dell'immagine",
  "width": "Larghezza",
  "tracingImageWidth": "Tracciare la larghezza dell'immagine",
  "height": "Altezza",
  "tracingImageHeight": "Tracciare l'altezza dell'immagine",
  "rotateLeft": "Ruotare a sinistra",
  "rotateRight": "Ruotare a destra",
  "fitImageToCanvas": "Montare l'immagine per la tela",
  "clearImage": "Immagine chiara",
  "pNGJPGJPEGAndWebPFilesAreSavedLocallyInTheFloorPlanLayoutJSONForNow": "I file PNG, JPG, JPEG e WebP vengono salvati localmente nel layout di piano JSON per ora.",
  "startWithAPolishedEmptyPlan": "Iniziare con un piano vuoto lucido",
  "addATableFromThePaletteDrawAWallOrDropInADoorEverythingSnapsToTheGrid": "Aggiungere un tavolo dalla tavolozza, disegnare un muro, o cadere in una porta. Tutto scatta alla griglia.",
  "seats": "sedili",
  "pressEscToExitFullScreen": "Premere Esc per uscire a schermo intero",
  "rotateHandle": "Maniglia girevole",
  "service": "Servizio",
  "inspector": "Ispettore",
  "multipleSelected": "Più selezionati",
  "selectAnItemToEditDetails": "Selezionare un elemento per modificare i dettagli.",
  "useTheLeftPaletteToAddWallsDoorsTablesBoothsBarsAndServiceStations": "Utilizzare la tavolozza sinistra per aggiungere pareti, porte, tavoli, cabine, bar e stazioni di servizio.",
  "chairsAreChildrenOfTableTemplatesClickAChairOnTheCanvasToDisableOrEnableThatSeat": "Sedie sono bambini di modelli da tavolo. Fare clic su una sedia sulla tela per disabilitare o abilitare quel sedile.",
  "doorOpening": "Porta / apertura",
  "tableObject": "Oggetto della tabella",
  "nameLabel": "Nome / etichetta",
  "zoneType": "Tipo di zona",
  "zoneTypeLabel": "Tipo di zona",
  "color": "Colore",
  "zoneColor": "Colore della zona",
  "zoneColorValue": "Valore di colore della zona",
  "zoneCapacity": "Capacità di zona",
  "activeTableSeats": "Sedili da tavolo attivi",
  "tablesInZone": "Tavole in zona",
  "activeTables": "Tabelle attive",
  "totalSeats": "Sedili totali",
  "includesInactiveTables": "Include tabelle inattive",
  "layerPosition": "Posizione del layer",
  "layer": "Livello",
  "showZone": "Mostra zona",
  "hiddenZonesAreNotShownButCanStillAssignReport": "Le zone nascoste non sono mostrate ma possono ancora assegnare/riportare.",
  "bringForward": "Avanti.",
  "sendBackward": "Inviare indietro",
  "bringToFront": "Portare davanti",
  "sendToBack": "Invia a indietro",
  "cloneZone": "Zona del clone",
  "tableNumber": "Numero della tabella",
  "linkedDiningTable": "Tavolo da pranzo collegato",
  "createOrLinkTable": "Creare o collegare la tabella",
  "createNewOnSave": "Crea nuovo su salva",
  "linkedDiningTableLabel": "Tavolo da pranzo collegato",
  "sourceOfTruth": "Fonte della verità:",
  "noArea": "Nessuna zona",
  "outlet": "Uscita",
  "noOutlet": "Nessuna presa di corrente",
  "capacityComesFromTheLinkedDiningTableSourceOfTruth": "La capacità deriva dalla fonte di verità del tavolo da pranzo collegato.",
  "capacityIsControlledByEnabledChairObjects": "La capacità è controllata da oggetti di sedia abilitati.",
  "points": "Punti",
  "edges": "Bordi",
  "segments": "Segmenti",
  "inactiveZonesDoNotAssignReport": "Le zone inattive non assegnano/riportano.",
  "inactiveObjectsAreFadedOnThePlan": "Gli oggetti inattivi sono sbiaditi sul piano.",
  "deleteZone": "Eliminare la zona",
  "deleteItem": "Eliminare l'elemento",
  "diningHostConsole": "Console per host di pranzo",
  "thePublishedFloorCouldNotBeDisplayed": "Il piano pubblicato non poteva essere visualizzato.",
  "reservationsAndServiceDataAreStillAvailable": "Le prenotazioni e i dati di servizio sono ancora disponibili.",
  "refreshingFloor": "Rinfresco pavimento...",
  "retryFloor": "Piano d'appoggio",
  "publishedDiningFloorPlan": "Pubblicato piano terra",
  "interactiveDiningFloorDragToMoveUseTheMouseWheelOrPinchGestureToZoom": "Piano pranzo interattivo. Passare per muoversi. Utilizzare la ruota del mouse o premere il gesto per ingrandire.",
  "zoomOut": "Zoom fuori",
  "fitFloor": "Piano di montaggio",
  "zoomIn": "Ingrandisci",
  "guestParty": "Festa degli ospiti",
  "authenticatedStaff": "Personale autenticato",
  "floor": "Piano terra",
  "unableToPrepareDiningOperations": "Incapace di preparare le operazioni di pranzo.",
  "unableToRefreshDiningOperations": "Incapace di rinfrescare le operazioni di pranzo.",
  "thisReservationChangedOnAnotherDeviceTheLatestDetailsHaveBeenLoaded": "Questa prenotazione è cambiata su un altro dispositivo. Gli ultimi dettagli sono stati caricati.",
  "actionFailed": "L'azione è fallita.",
  "waitlist": "Lista d’attesa",
  "arrived": "Arrivati",
  "seated": "Seduta",
  "available": "Disponibile",
  "late": "Tardi",
  "noShows": "Nessun programma",
  "weCouldnTLogYouOutPleaseTryAgain": "Non siamo riusciti a tirarti fuori, per favore riprova.",
  "noDiningAreasConfigured": "Nessuna zona pranzo configurata",
  "covers": "coperture",
  "signOut": "Firma",
  "hostConsole": "Consolle host",
  "todaySOperationalSummary": "Riepilogo operativo di oggi",
  "preparingTodaySFloorAndReservations": "Preparare il pavimento e le prenotazioni di oggi...",
  "liveFloor": "Live Piano",
  "refreshing": "Raffreddamento",
  "noActiveDiningAreasAreConfigured": "Nessuna zona pranzo attiva è configurata",
  "noActiveDiningTablesAreConfigured": "Non sono configurate tabelle di pranzo attive",
  "noPublishedFloorPlanIsAvailableForThisArea": "Nessun piano pubblicato è disponibile per questa zona",
  "markThisReservationAsNoShow": "Contrassegnare questa prenotazione come mancata presentazione?",
  "completeThisDiningVisit": "Completa questa visita da pranzo?",
  "comingNextThisPhaseKeepsFocusOnLiveFloorAndReservationOperations": "Arrivo dopo. Questa fase continua a concentrarsi sulle operazioni di live floor e di prenotazione.",
  "servicePulse": "Impulso di servizio",
  "noReservationsForToday": "Nessuna prenotazione per oggi",
  "activeReservations": "Prenotazioni attive",
  "unassigned": "Non assegnato",
  "noReservationsForThisDate": "Nessuna prenotazione per questa data",
  "next45Days": "I prossimi 45 giorni",
  "futureReservations": "Prenotazioni future",
  "noFutureReservations": "Nessuna prenotazione futura",
  "markArrived": "Mark è arrivato",
  "runningLate": "Correre in ritardo",
  "assignTable": "Tabella delle assegnazioni",
  "noShowLabel": "Mancata presentazione",
  "seatParty": "Sedile partito",
  "seatAssignTable": "Sedile / assegna la tabella",
  "changeTable": "Cambia tabella",
  "completeVisit": "Visita completa",
  "close": "Chiudi",
  "member": "Socio",
  "status": {
    "pending": "in attesa",
    "confirmed": "confermato",
    "checked_in": "verificata",
    "seated": "Seduta",
    "completed": "completato",
    "cancelled": "annullata",
    "no_show": "mancata presentazione",
    "available": "disponibile",
    "assigned": "assegnato",
    "reserved_soon": "riservato presto",
    "arrived": "arrivato",
    "blocked": "bloccato",
    "inactive": "inattivo"
  },
  "party": "Partito",
  "notesAllergyIndicators": "Note / indicatori di allergia",
  "viewOnlyDiningBookingsAccess": "Visualizza solo Ceneri Accesso prenotazioni",
  "upcomingAssigned": "Prossima / assegnata",
  "noUpcomingReservationsAssignedToThisTable": "Nessuna prossima prenotazione assegnata a questa tabella.",
  "invalidClubRoute": "Itinerario del club non valido",
  "useACanonicalSixDigitClubCode": "Utilizzare un codice del club canonico a sei cifre.",
  "accessDeniedLabel": "Accesso negato",
  "unableToLoadHostConsole": "In grado di caricare Host Console",
  "privanaCouldNotCompleteClubResolutionOrAuthorisationPleaseRetry": "Privana non poteva completare la risoluzione o l'autorizzazione del club. Per favore, riprovate.",
  "signingYouOut": "Segnalarti...",
  "enterAClubRoute": "Immettere un percorso di club",
  "open123001ToStartDiningHostConsole": "Aprire /123001 per iniziare Console Host Pasticceria.",
  "deactivateArea": "Disattivare {name}?",
  "deactivateTable": "Disattivare la tabella {label}?",
  "cancellationDescription": "Configurare la cancellazione dei soci per {name} .",
  "noTablesForArea": "Ancora nessun tavolino. Aggiungi i tavoli per {name} .",
  "areaQrSummary": "Generando un'area QR per {name} .",
  "tableQrSummary": "Generando QR da tavolo per {name} ({count} tabelle attive).",
  "tableQrSummaryOne": "Generando QR da tavolo per {name} ({count} tabelle attive).",
  "qrPreview": "{label} Anteprima QR",
  "urlCopied": "URL copiato",
  "reservationReference": "Prenotazione {reference}",
  "areaTable": "{area} · Tabella {table}",
  "tableLabel": "Tabella {label}",
  "pagination": "{from} – {to} di {total}",
  "validWindow": "Immettere un inizio e un termine valido per {day} .",
  "overlappingWindows": "{day} finestre di servizio non possono sovrapporsi.",
  "selectedObjects": "{count} oggetti selezionati. Trascinare qualsiasi oggetto selezionato per spostare il gruppo o utilizzare le scorciatoie da tastiera per duplicare, eliminare e nudge.",
  "linkedTableSummary": "Fonte di verità: {label} · {capacity} posti · {status} .",
  "resizeHandle": "Ridimensiona {handle}",
  "zonePointHandle": "Punto zona {number} maniglia",
  "wallPointHandle": "Diametro parete {number} maniglia",
  "tableState": "Tabella {label} , {status}",
  "signOutStaff": "Firma {name}",
  "coverCountOne": "{count} coperti",
  "coverCountOther": "{count} coperti",
  "activeCount": "{count} attivo",
  "publishedLayout": "layout Pubblicato · {name}",
  "serviceSummary": "{waiting} in attesa · {seated} seduti · {available} tavoli disponibili · {completed} completati.",
  "lateStatus": "{status} · in ritardo",
  "dateReservations": "{date} prenotazioni",
  "upcomingSummary": "{time} · {count} ospiti · {status}",
  "unauthorisedClub": "Il tuo account non è autorizzato per l'accesso di Dining Host Console al club {clubCode} .",
  "selectDate": "Seleziona la data",
  "chooseServiceDate": "Scegli la data di servizio",
  "serviceDate": "Data di servizio",
  "unknownStatus": "Stato sconosciuto",
  "unknownSource": "Sorgente sconosciuta",
  "genericError": "Non è possibile completare la richiesta di pranzo. Si prega di riprovare.",
  "requestReference": "{message} (ID di richiesta: {requestId} )",
  "authRestoring": "ripristino... sessione",
  "authAuthenticating": "autenticare",
  "authResolving": "risuonare... club",
  "authAuthorising": "autorevolezza",
  "authLoading": "carico di carico",
  "topLeft": "alto a sinistra",
  "topRight": "superiore a destra",
  "bottomLeft": "in basso sinistra",
  "bottomRight": "in basso a destra",
  "source": {
    "staff": "Personale",
    "member_portal": "Portale dei soci",
    "members_mobile": "App per i soci",
    "guest": "Ospite",
    "walk_in": "Camminare"
  },
  "errors": {
    "slot_unavailable": "La tabella o l'ora selezionata non sono più disponibili.",
    "party_size_out_of_range": "La dimensione del partito è al di fuori della gamma consentita.",
    "invalid_party_size": "Inserire una dimensione del partito valida.",
    "invalid_guest_name": "Inserire un nome ospite.",
    "invalid_guest_email": "Inserisci un indirizzo e-mail valido per gli ospiti.",
    "invalid_guest_phone": "Inserisci un numero di telefono ospite valido.",
    "invalid_member_id": "Selezionare un socio valido.",
    "member_not_found": "Il socio non poteva essere trovato.",
    "area_not_found": "La zona pranzo non è stata trovata.",
    "table_not_found": "Il tavolo non poteva essere trovato.",
    "reservation_not_found": "La prenotazione non è stata trovata.",
    "reservation_terminal": "Questa prenotazione non può più essere cambiata.",
    "invalid_status_transition": "Questo cambiamento di stato non è consentito.",
    "reason_required": "Inserisci un motivo per questa azione.",
    "invalid_local_datetime": "Inserisci una data e l'ora di prenotazione validi.",
    "invalid_local_time": "Questa ora locale non è valida nel fuso orario del club.",
    "ambiguous_local_time": "Questa volta si verifica due volte quando gli orologi cambiano. Scegliere un'altra volta.",
    "invalid_duration": "Inserisci una durata valida.",
    "duration_not_permitted": "Questa durata non è consentita.",
    "minimum_notice_not_met": "L'avviso minimo di prenotazione non è stato soddisfatto.",
    "outside_service_window": "La prenotazione è al di fuori delle finestre di servizio.",
    "booking_interval_mismatch": "Scegliere un tempo che corrisponde all'intervallo di prenotazione.",
    "reservation_day_unavailable": "Le prenotazioni non sono disponibili in questo giorno di servizio.",
    "reservation_date_out_of_range": "La data di prenotazione è al di fuori della gamma consentita.",
    "reservations_unavailable": "Le prenotazioni non sono disponibili per questa zona pranzo.",
    "walk_ins_disabled": "I walk-in sono disabilitati per questa zona pranzo.",
    "guest_reservations_disabled": "Le prenotazioni degli ospiti sono disabilitate per questa zona pranzo.",
    "table_block_conflicts_with_reservation": "Il blocco della tabella si scontra con una prenotazione.",
    "block_not_found": "Il blocco del tavolo non è stato trovato.",
    "invalid_table_block": "Inserire un blocco di tabella valido.",
    "invalid_date_filter": "Inserire un filtro data valido.",
    "invalid_range": "Inserire una gamma di numeri valida.",
    "rate_limited": "Troppe richieste. Si prega di riprovare a breve.",
    "invalid_upload": "Selezionare un'immagine da caricare.",
    "invalid_image_type": "Caricare un'immagine JPEG, PNG o WebP valida.",
    "malformed_image": "L'immagine è corrotta, troncata, o non può essere decodificata.",
    "image_too_large": "Le immagini devono essere 5 MB o meno.",
    "service_windows_required": "Aggiungi almeno una finestra di servizio.",
    "overlapping_service_windows": "Le finestre di servizio non possono sovrapporsi.",
    "invalid_reservation_settings": "Controllare le impostazioni della prenotazione.",
    "invalid_party_size_range": "La dimensione minima del partito non può superare la dimensione massima del partito.",
    "invalid_reservation_time_increment": "Gli intervalli di prenotazione e le durate devono utilizzare incrementi di cinque minuti.",
    "invalid_booking_interval": "Inserisci un intervallo di prenotazione tra 5 e 240 minuti.",
    "invalid_default_duration": "Inserisci una durata predefinita tra 15 e 720 minuti.",
    "invalid_minimum_party_size": "Inserire una dimensione minima del partito tra 1 e 100.",
    "invalid_maximum_party_size": "Inserire una dimensione massima del partito tra 1 e 500.",
    "invalid_maximum_days_ahead": "Inserisci un orizzonte di prenotazione tra 0 e 730 giorni.",
    "invalid_minimum_notice": "Inserisci un avviso minimo tra 0 e 10080 minuti.",
    "invalid_cancellation_window": "Inserisci una finestra di cancellazione tra 0 e 43200 minuti.",
    "invalid_service_window_time": "Inserire un valido servizio-fine orario di inizio e fine.",
    "invalid_service_window_day": "Selezionare una giornata di servizio valida.",
    "service_window_day_disabled": "Abilitare il giorno della prenotazione prima di aggiungere una finestra di servizio.",
    "invalid_service_windows": "Controlla le finestre di servizio.",
    "invalid_service_window": "Controlla la finestra di servizio.",
    "invalid_reservation_days": "Selezionare giorni di prenotazione validi.",
    "unknown_reservation_setting": "Le impostazioni della prenotazione contengono un'opzione non supportata.",
    "invalid_area_id": "Seleziona una zona pranzo valida.",
    "invalid_table_id": "Seleziona una tabella valida.",
    "table_not_in_area": "La tabella selezionata non appartiene a questa zona pranzo.",
    "duplicate_linked_table": "Ogni tavolo visivo attivo può collegarsi a un tavolo da pranzo solo una volta.",
    "linked_table_invalid": "Il tavolo da pranzo collegato non è valido.",
    "invalid_status": "Selezionare uno stato di prenotazione valido.",
    "invalid_booking_source": "Selezionare una fonte di prenotazione valida.",
    "invalid_search": "Inserisci una ricerca valida.",
    "invalid_start_at": "Inserisci un'ora di inizio di prenotazione valida.",
    "invalid_reservation_id": "Selezionare una prenotazione valida.",
    "floor_plan_not_found": "Il piano del pavimento non poteva essere trovato.",
    "invalid_floor_plan_id": "Selezionare un piano di pavimento valido."
  },
  "vip": "VIP",
  "reservationCount": "{count} prenotazioni",
  "logoutTitle": "Esci da Privana?",
  "logoutDescription": "Sei sicuro di voler uscire?",
  "loggingOut": "E' in ritardo...",
  "logOut": "Effettua il login",
  "print": {
    "heading": "RISTORAZIONE PRIVANA",
    "instruction": "Scansione per visualizzare il menu",
    "area": "Sala da pranzo QR",
    "table": "QR della tabella"
  },
  "reminder": {
    "title": "Promemoria prenotazione pranzo",
    "body": "La vostra prenotazione di pranzo {reference} sta arrivando."
  },
  "seatCount": "{count} posti",
  "partyStatus": "{count} ospiti · {status}",
  "guestCount": "{count} ospiti",
  "saved": "Cambiamenti salvati.",
  "activeCountOne": "{count} attivo",
  "reservationCountOne": "{count} prenotazioni",
  "seatCountOne": "{count} posti",
  "guestCountOne": "{count} ospiti",
  "partyStatusOne": "{count} ospiti · {status}",
  "linkedTableSummaryOne": "Fonte di verità: {label} · {capacity} posti · {status} .",
  "statusLabel": "Stato",
  "layerSummary": "Livello {position} di {total}",
  "elapsedMinutes": "{count} m",
  "resizeCorner": {
    "nw": "No.",
    "ne": "Necessario",
    "se": "Se non lo fosse",
    "sw": "- Si'."
  },
  "missingPolicyHandler": "Non è possibile salvare la politica di cancellazione. Salvare il gestore non è configurato."
};
